import styled from "styled-components";
import { VerticalTimeline } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

export const TimelinePageWrapper = styled.section`
  background: linear-gradient(180deg, #ffffff 0%, #f5f8ea 100%);
  padding: 26px 0 36px;
`;

export const AboutIntro = styled.div`
  width: min(980px, 92%);
  margin: 0 auto 1.1rem;
  text-align: center;

  p {
    margin: 0.75rem 0 0;
    line-height: 1.9;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const AboutIntroKicker = styled.p`
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkBackground};
  opacity: 0.72;
`;

export const AboutIntroTitle = styled.h1`
  margin: 0.6rem 0 0;
  font-size: clamp(1.8rem, 4vw, 2.7rem);
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.darkBackground};
`;

export const CustomVerticalTimeline = styled(VerticalTimeline)`
  width: min(1120px, 94%);

  .vertical-timeline-element-content {
    border-radius: 12px;
    box-shadow: 0 12px 26px rgba(10, 10, 10, 0.08);
  }

  .vertical-timeline-element-subtitle {
    font-weight: 200;
    margin-bottom: 0.45rem;
  }

  .vertical-timeline-element-icon {
    display: none !important;
  }

  .vertical-timeline-element-content::before {
    display: none !important;
  }

  .vertical-timeline--two-columns .vertical-timeline-element-content,
  .vertical-timeline--one-column-right .vertical-timeline-element-content {
    margin-left: 0 !important;
  }

  @media (max-width: 1169px) {
    .vertical-timeline-element-date {
      font-weight: 700 !important;
    }
  }
`;

export const TimeLineDescription = styled.p`
  width: 100%;
  margin: 0 auto;
  padding: 15px;
  @media (min-width: 1023px) {
    width: 60%;
  }
`;

export const TeamImageWrapper = styled.div`
  width: min(900px, 92%);
  margin: 0 auto;
  padding-top: 0.8rem;
`;

export const TeamImage = styled.img`
  width: 100%;
  max-width: 760px;
  display: block;
  margin: 0 auto;
  border-radius: 14px;
  box-shadow: 0 16px 30px rgba(10, 10, 10, 0.12);

  @media (max-width: 767px) {
    max-width: 100%;
  }
`;

export const TeamImageCaption = styled.p`
  margin: 0.75rem auto 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.text};
  width: min(680px, 100%);
`;
